import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../../../../Support/with_presenter';
import {ThisWeekPresenter} from './ThisWeekPresenter';
import {FullCrew} from '../../../../../../Models/Crew';
import {classNames} from '../../../../../Support/classNames';
import {NetworkRequestStatusView} from '../../../../../Components/Utils/NetworkRequestStatusView';
import {Loader} from '../../../../../Components/Utils/Loader';
import {formatDistanceCompact} from '../../../../../Support/Formatting/formatDistance';

interface OwnProps {
    crew: FullCrew;
    className?: string;
}

const ThisWeekComponent: FunctionComponent<OwnProps & PresenterProps<ThisWeekPresenter>> = observer(
    ({crew, className, presenter}) => {
        return (
            <div className={classNames('card', className)}>
                <div className="card-title">
                    <h5>This week</h5>
                </div>
                <div className="card-body">
                    <NetworkRequestStatusView
                        result={presenter.weekReport}
                        loader={() => {
                            return <Loader />;
                        }}
                        error={() => {
                            return <Loader />;
                        }}
                        component={(weekReport) => {
                            const formattedDistance = formatDistanceCompact(weekReport.traveledDistance);
                            return (
                                <div>
                                    <dl>
                                        <dt>Total distance</dt>
                                        <dl>
                                            {formattedDistance.formatted}
                                            {formattedDistance.unit}
                                            {weekReport.activeMembers.length > 0 && (
                                                <small className="text-muted">
                                                    {' '}
                                                    by {weekReport.activeMembers.length}{' '}
                                                    {weekReport.activeMembers.length === 1 ? 'member' : 'members'}
                                                </small>
                                            )}
                                        </dl>
                                    </dl>
                                    <dl>
                                        <dt>Active</dt>
                                        <dl className="d-flex gap-1 flex-wrap">
                                            {weekReport.activeMembers.length === 0 && <span>-</span>}
                                            {weekReport.activeMembers.map((member) => {
                                                return (
                                                    <span className="badge rounded-pill bg-primary">
                                                        {member.displayName}
                                                    </span>
                                                );
                                            })}
                                        </dl>
                                    </dl>
                                    <dl>
                                        <dt>Inactive</dt>
                                        <dl className="d-flex gap-1 flex-wrap">
                                            {weekReport.inactiveMembers.length === 0 && <span>-</span>}
                                            {weekReport.inactiveMembers.map((member) => {
                                                return (
                                                    <span className="badge rounded-pill bg-secondary">
                                                        {member.displayName}
                                                    </span>
                                                );
                                            })}
                                        </dl>
                                    </dl>
                                </div>
                            );
                        }}
                    />
                </div>
            </div>
        );
    },
);

export const ThisWeek = withPresenter<ThisWeekPresenter, OwnProps>(
    (props, component) => new ThisWeekPresenter(props.crew.id, component.network.workouts),
    ThisWeekComponent,
);
